<template>
  <v-dialog v-model="status" width="500">
    <v-card>
      <v-card-title
        :class="`headline accent-3 ${this.error == 1 ? 'error' : 'success'}`"
        primary-title
      >
        {{ this.error == 1 ? "Error" : "Success" }}
      </v-card-title>

      <v-card-text>
        {{ message }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red accent-3" flat @click="status = false">close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: ["value", "error", "message"],
    data() {
      return {
        status: this.value,
      };
    },
    watch: {
      value() {
        this.status = this.value;
      },
      status() {
        this.$emit("input", this.status);
      },
    },
  };
</script>
